class MeshRestrictionHelper {
    constructor() {
        {
            this.RestrictionTypeEnum = {
                MOVE_AND_ROTATE: 'MoveAndRotate',
                HIGHLIGHT: 'Highlight',
                VISIBILITY: 'Visibility',
                TRANSPARENCY: 'Transparency',
            };

            this.RestrictedMeshTypeEnum = {
                VOLUME: "Volume",
                MODEL: "Model",
                TREE: "Tree",
                GROUP: "Group"
            };

            this.RestrictionMode = {
                ALLOW: 'Allow',
                ALLOW_ALL: 'AllowAll',
                DENY: 'Deny',
                DENY_ALL: 'DenyAll'
            };
        }
    }
}

let meshRestrictionHelper = new MeshRestrictionHelper();
export default meshRestrictionHelper;